import template from './phonesList.template.html';

export default {
  template,
  bindings: {
    phones: '=',
    accounts: '=',
    onClick: '&',
    onChange: '&',
    onReady: '&'
  },
controller: class controller {
    constructor($rootScope, $mdMedia, listService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.currentDateFormat = null;
      ctrl.$mdMedia = $mdMedia;
      ctrl.list = listService;
      ctrl.list.clear();

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = () => {
        ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
        ctrl.list.setData(ctrl.phones);
        ctrl.onReady({ list: ctrl.list });
      };
      this.formatDate = (inputDate) =>
        moment(inputDate, 'YYYY-MM-DD').format(ctrl.currentDateFormat);
      this.click = ($event, data) => {
        ctrl.onClick({ event: $event, data: data });
      };
      this.select = (data) => {
        const isSelected = ctrl.list.setSelected(data);
        ctrl.onChange({ list: ctrl.list, data, isSelected });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = () => {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = (changes) => {
        if (changes.phones && changes.phones.currentValue) {
          ctrl.initialize();
        }
      };
    }
  }
};
